export enum IconsNamesEnum {
  HOTEL = "fa fa-hotel",
  SHUTTLE_VAN = "fa fa-bus",
  PLANE = "fa fa-plane",
  TRANSIT_CARD = "fa fa-file",
  PARK_ENTRANCE = "fa fa-ticket",
  LIST = "fa fa-list",
  VIP = "fa fa-street-view",
}
